import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { getRoles } from "src/models/Role";
import errorDialog from "src/functions/function-show-error-message";
import getErrorPayload from "src/functions/get-error-payload"; // Init state

var initState = function initState() {
  return {
    roles: ""
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  setRoles: function setRoles(state, payload) {
    state.roles = payload;
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  fetchRoles: function fetchRoles(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      getRoles().then(function (response) {
        commit("setRoles", response.data.data);
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  }
}; // Getter functions

var getters = {
  roles: function roles(state) {
    return state.roles;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};